import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { boostLocationRoute } from '@features/boostMyJobs/api/constants';
import axiosInstance from '@server/axiosInstance';
import { paymentDetails } from '@features/payments';

type UseBoostLocationProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useBoostLocation = ({ setErrorText }: UseBoostLocationProps) => {
  const client = useQueryClient();

  const { mutate: boostLocation, isLoading: isBoostLocationLoading } =
    useMutation({
      mutationFn: (variables: { number_weeks: number; token?: string }) =>
        axiosInstance
          .post(boostLocationRoute, variables)
          .then((res) => res.data),

      onMutate: () => {
        setErrorText('');
      },

      onSuccess: (data) => {
        if (data.status === 200) {
          client.invalidateQueries([paymentDetails]);
          setErrorText('');
        } else {
          setErrorText(data?.message || errorMessage);
        }
      },
      onError: (error: { response?: { data?: { message?: string } } }) => {
        setErrorText(error?.response?.data?.message || errorMessage);
      },
    });

  return {
    boostLocation,
    isBoostLocationLoading,
  };
};
